import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Input,
  Container,
  Col,
  Row,
  Button,
  Alert,
} from "reactstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { requestForgotPassword } from "../../store/user/actions";
import { validationHelper } from "../../common/helpers";
class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      emailError: false,
    };

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }

  handleSubmit() {
    if (!this.validateFields()) return;
    this.props.requestForgotPassword(this.state.email);
  }

  validateFields() {
    if (!validationHelper.isEmail(this.state.email)) {
      this.setState({ emailError: true });
      return false;
    }

    this.setState({ emailError: false });
    return true;
  }

  renderForgotPasswordForm() {
    const { error, loading } = this.props;
    const { email, emailError } = this.state;

    return (
      <div>
        {error && (
          <Row>
            <Col>
              <Alert color="danger">{error}</Alert>
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <p>
              Ingresa el correo electrónico con el que se registró tu cuenta:
            </p>
            <Input
              type="email"
              placeholder="Correo electrónico"
              onChange={this.handleEmailChange}
              value={email}
              invalid={emailError}
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <Button
              color="primary"
              disabled={loading}
              className="mr-1"
              onClick={this.handleSubmit}
            >
              Aceptar
            </Button>
            <Button
              color="secondary"
              onClick={() => this.props.history.push("/login")}
            >
              Cancelar
            </Button>
          </Col>
        </Row>
      </div>
    );
  }

  renderSuccess() {
    const { success } = this.props;
    const { email } = this.state;

    return (
      <div>
        <Row>
          <Col>
            <Alert color="success">
              {`Se envió un correo electrónico a ${email} para confirmar la solicitud.`}
            </Alert>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              disabled={!success}
              color="primary"
              onClick={() => this.props.history.push("/login")}
            >
              Aceptar
            </Button>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const { success } = this.props;

    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="2" lg="3" />
            <div className="col-md-8 col-lg-6">
              <Card>
                <CardHeader>Reestablecer tu contraseña</CardHeader>
                <CardBody>
                  {!success
                    ? this.renderForgotPasswordForm()
                    : this.renderSuccess()}
                </CardBody>
              </Card>
            </div>
            <Col md="2" lg="3" />
          </Row>
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { success, error, loading } = state.user.forgotPassword;

  return {
    success,
    error,
    loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      requestForgotPassword,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/scenes/ForgotPassword/ForgotPassword.js